"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuButton = void 0;
var _Layout = require("../Layout");
var _Theme = require("../Theme");
var _MenuContext = require("./MenuContext");
var _react = require("@floating-ui/react");
var _react2 = require("@headlessui/react");
var _classnames = _interopRequireDefault(require("classnames"));
var _react3 = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const MenuButton = /*#__PURE__*/(0, _react3.forwardRef)((_ref, ref) => {
  let {
    className,
    children,
    selected,
    ...props
  } = _ref;
  const {
    overlayData: {
      refs,
      getReferenceProps
    }
  } = (0, _MenuContext.useMenuContext)();
  const refProp = (0, _react.useMergeRefs)([refs.setReference, ref]);
  const {
    theme: {
      menu: {
        button: buttonTheme
      }
    }
  } = (0, _Theme.useThemeConfig)();
  return /*#__PURE__*/_react3.default.createElement(_react2.Menu.Button, {
    as: _react3.Fragment
  }, _ref2 => {
    let {
      open
    } = _ref2;
    return typeof children === "function" ? children({
      open,
      refProp,
      getReferenceProps
    }) : /*#__PURE__*/_react3.default.createElement(_Layout.Box, _extends({
      as: "button",
      ref: refProp,
      selected: selected,
      className: (0, _classnames.default)(className, buttonTheme.base)
    }, getReferenceProps(props)), children);
  });
});
exports.MenuButton = MenuButton;
MenuButton.displayName = "Menu.Button";